var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TarjetaDatos',{attrs:{"titulo":"Conductor"}},[_c('Campo2L',{attrs:{"valor":_vm.conductor.nombre}}),_c('Campo2L',{attrs:{"valor":_vm._f("dateDDMMYYYY")(_vm.conductor.fecNacimiento),"etiqueta":"Fecha Nacimiento"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }